module.exports = __webpack_public_path__ + "img/file.bbc0567e.svg";